import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// 创建 pinia 实例
export const pinia = createPinia()
// 使用持久化存储插件
pinia.use(piniaPluginPersistedstate as any)
